import { IAutomationObject } from '../../types'

export interface IAnalogSetpoint extends IAutomationObject {
    value: number;
    dimension: string;
    limitMin: number;
    limitMax: number;
    onValueChanged: any;
}


export const schema = 'AutomationApps.Functions.SetPoints.DigitalSetpoint';



